import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

import { RenderWhen } from "../../../../../../components";
import { IntegrationType } from "../../../../@types";
import { isSampleAnalyzing } from "../../../../util";
import styles from "../analysis-card.module.scss";
import AnalyzeButton from "./AnalyzeButton";

type Props = {
  integration: IntegrationType;
  hasResult: boolean;
  status?: string;
};

const IntegrationsValue: FC<PropsWithChildren<Props>> = ({
  integration,
  hasResult,
  status,
  children
}) => {
  const isAnalyzing = isSampleAnalyzing(status ?? "");
  return (
    <div className={clsx(styles.list_item_value, "width-40-pc")}>
      <RenderWhen
        condition={hasResult || isAnalyzing}
        fallback={<AnalyzeButton integration={integration} status={status} />}
      >
        {isAnalyzing ? "Analyzing..." : children}
      </RenderWhen>
    </div>
  );
};

export default IntegrationsValue;
